

































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { TbGrade } from '@/http';
@Component({
    components: {
      
    },
})
export default class birthdayPanel extends Vue {
    public $refs: {
    };
    columnsUnit= [];
    
    show = false;

    defaultIndex = 0;

    birthdayTime="";
    minDate= new Date(1972, 0, 1);

    created() {
    }
    mounted() {
     
        
    }

    moveHandle() {}
    onClose(){
        this.show = false;
    }
    Confirm(value){
        this.$emit("birthdyConfirm",value);
        this.show = false;
    }


    formatter(type, value) {
        if (type === "year") {
            return `${value}年`;
        }
        if (type === "month") {
            return `${value}月`;
        }
        return `${value}日`;
    }
   
    async showFun(val){
        await this.init();
        if(val){
            this.defaultIndex  = this.columnsUnit.findIndex(v=>v.id==val);
        }
        this.show = true;
    }

    async init(){
        let res = await TbGrade.GetGradeList();
        this.columnsUnit = res;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/birthdayPanel.vue